import React, { forwardRef, type ReactNode } from "react";

import { cn } from "src/shadcn/lib/utils";
import { DropdownMenuGroup } from "src/primitives/DropdownMenu";

interface MenuProps extends React.ComponentProps<"div"> {
  children?: ReactNode;
  className?: string;
}

const Menu = forwardRef<HTMLDivElement, MenuProps>(
  ({ children, className, ...otherProps }, ref) => (
    <DropdownMenuGroup
      ref={ref}
      className={cn("flex flex-col", className)}
      {...otherProps}
    >
      {children}
    </DropdownMenuGroup>
  )
);
Menu.displayName = "Dropdown.Menu";

export { Menu };
